"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("@formsort/constants");
function isRecord(val) {
    return val !== null && typeof val === 'object';
}
function isString(val) {
    return typeof val === 'string';
}
/**
 * Checks if `val` is equal to one of the values of the enum
 * @param val
 * @param anEnum
 */
var isEnumMember = function (val, anEnum) {
    return Object.values(anEnum).includes(val);
};
function isIWebEmbedEventData(val) {
    return (isRecord(val) &&
        isString(val.type) &&
        isEnumMember(val.type, constants_1.WebEmbedMessage));
}
exports.isIWebEmbedEventData = isIWebEmbedEventData;
/**
 * Note: The type guards below are not comprehensive -
 * i.e. we are not checking that all properties of the expected type exist
 * on the given value.
 */
function isIframeAnalyticsEventData(data) {
    return data.type === constants_1.WebEmbedMessage.EMBED_EVENT_MSG;
}
exports.isIframeAnalyticsEventData = isIframeAnalyticsEventData;
function isIFrameRedirectEventData(data) {
    return data.type === constants_1.WebEmbedMessage.EMBED_REDIRECT_MSG;
}
exports.isIFrameRedirectEventData = isIFrameRedirectEventData;
function isIFrameResizeEventData(data) {
    return data.type === constants_1.WebEmbedMessage.EMBED_RESIZE_MSG;
}
exports.isIFrameResizeEventData = isIFrameResizeEventData;
